import React from 'react';
import { Field, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, ComboBox } from '@components';
import {
  RecebimentoCorrespondenciaInitialValues,
  RecebimentoCorrespondenciaSchema,
} from '@schemas';
import { constantesRequerimentos } from '@utils';
import { enviarRequerimentoFormulario } from '../../../../store/requerimentos/thunks';

const { SEM_JORNAL, SEM_CORRESPONDENCIA } = constantesRequerimentos;

export const RecebimentoCorrespondencia = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const envioLoading = useSelector(
    (state) => state.requerimentos.envio.loading
  );

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>
        <Formik
          validateOnMount
          initialValues={RecebimentoCorrespondenciaInitialValues}
          validationSchema={RecebimentoCorrespondenciaSchema}
          onSubmit={(values) => {
            dispatch(
              enviarRequerimentoFormulario({
                campos: values,
                formulario: reference,
              })
            )
              .unwrap()
              .then(() => {
                navigate('/requerimentos/andamento');
              });
          }}
        >
          {({ handleSubmit, isValid }) => (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 col-lg-6">
                  <Field
                    className="mb-3"
                    name="opcaoRecebimento"
                    component={ComboBox}
                    label="Opção de recebimento"
                    options={[SEM_JORNAL, SEM_CORRESPONDENCIA].map((x) => {
                      return { value: x, label: x };
                    })}
                  />
                </div>
              </div>

              <hr className="mt-32 mt-xs-0 mb-32" />

              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid || envioLoading}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      Continuar
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
